<template>
  <div>
    <!-- <Top></Top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img v-lazy="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">智慧门店</div>
          <div class="contentBottom">
            <div>基于物联网、大数据分析，实现线上线下一体化服务及运营</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle">方案价值</div>
      <div class="lineCss"></div>
    </div>
    <div class="contentTextOne">针对消费者及品牌，进行针对性的需求分析。在提升消费者购物体验的同时，通过智屏OS管理端，让品牌实时获取消费数据，及时调整或升级营销策略。</div>
    <div class="planValue">
      <!-- start -->
      <div class="planValueTu">
        <div class="planValueLeft">
          <img v-lazy="wisdomLeftFu" alt class="valueLeft">
        </div>
        <div class="planValueRight">
          <img v-lazy="valueRight" alt class="valueLeft">
        </div>
      </div>
      <!-- end -->
    </div>
    <!-- end -->
    <!-- start -->
    <div class="changJing">
      <div class="titleBox">
        <div class="anliTitle" style="margin-top:118px">场景应用</div>
        <div class="lineCss"></div>
      </div>
      <!-- start -->
      <div class="changJingBox">
        <div class="boxTitle marginTop89">进店</div>
        <div class="tabBoxParent">
          <img v-lazy="boxImg1" alt class="contentBgImg">
          <!-- 底部 tab start -->
          <div class="tabFlex">
            <div class="tabBox">
              <div class="tabBoxText">云拼接互动墙</div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText">AR迎宾</div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText">微笑领红包</div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText">互动游戏屏</div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
          </div>
          <!-- 底部 tab end -->
        </div>
      </div>
      <!-- end -->
      <!-- start -->
      <div class="changJingBox">
        <div class="boxTitle">选购</div>
        <div class="tabBoxParent">
          <img v-lazy="boxImg2" alt class="contentBgImg">
          <!-- 底部 tab start -->
          <div class="tabFlex">
            <div class="tabBox">
              <div class="tabBoxText">星辰云货架</div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText">时尚志</div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText">交互式货架</div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText"></div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
          </div>
          <!-- 底部 tab end -->
        </div>
      </div>
      <!-- end -->
      <!-- start -->
      <div class="changJingBox">
        <div class="boxTitle">试穿</div>
        <div class="tabBoxParent">
          <img v-lazy="boxImg3" alt class="contentBgImg">
          <!-- 底部 tab start -->
          <div class="tabFlex">
            <div class="tabBox">
              <div class="tabBoxText">CC试衣镜</div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText"></div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText"></div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText"></div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
          </div>
          <!-- 底部 tab end -->
        </div>
      </div>
      <!-- end -->
      <!-- start -->
      <div class="changJingBox">
        <div class="boxTitle">购买</div>
        <div class="tabBoxParent">
          <img v-lazy="boxImg4" alt class="contentBgImg">
          <!-- 底部 tab start -->
          <div class="tabFlex">
            <div class="tabBox">
              <div class="tabBoxText">智能优惠购</div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText"></div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText"></div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
            <div class="tabBox">
              <div class="tabBoxText"></div>
              <img v-lazy="tabLineImg" alt class="tobLineImgCss">
            </div>
          </div>
          <!-- 底部 tab end -->
        </div>
      </div>
      <!-- end -->
    </div>
    <!-- end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:118px">实施方案</div>
      <div class="lineCss"></div>
    </div>
    <!-- bottom start -->
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomTitle">有屏门店</div>
        <img v-lazy="planLeftImg" alt>
        <div class="imgBottomTitle">原屏幕+数拓盒子</div>
        <div class="imgBottomText">
          通过HDMI线，让屏幕接入数拓智能盒子，
          联网后即可接入数拓云服务。
        </div>
        <div class="imgBottomFlex">
          <div class="imgBottomBox">
            <img v-lazy="yingJianImg1" alt>
            <div class="v5Css">V5</div>
          </div>
          <div class="imgBottomBox">
            <img v-lazy="yingJianImg1" alt>
            <div class="v5Css">V8</div>
          </div>
        </div>
      </div>
      <div class="bottomRight">
        <div class="bottomTitle">无屏门店</div>
        <img v-lazy="planRightImg" alt>
        <div class="imgBottomTitle">数拓商显一体机</div>
        <div class="imgBottomText">
           内置数拓智能播放系统，只需接电、联网，即可接入数拓云服务。
        </div>
        <div class="imgBottomFlex">
          <div class="imgBottomBox">
            <img v-lazy="yingJianImg4" alt>
            <div class="v5Css">一体机</div>
          </div>
          <div class="imgBottomBox">
            <img v-lazy="yingJianImg5" alt>
            <div class="v5Css">8mm拼接屏</div>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom end -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:134px">典型案例</div>
      <div class="lineCss"></div>
    </div>
    <div class="anLiFlex">
      <div class="anLiBox">
        <img v-lazy="anLiBoxImg1" class="anLiBigImg" alt>
        <!-- <div class="positionText">特步</div> -->
      </div>
      <div class="anLiBox">
        <img v-lazy="anLiBoxImg2" class="anLiBigImg" alt>
        <!-- <div class="positionText">艾莱依</div> -->
      </div>
      <div class="anLiBox">
        <img v-lazy="anLiBoxImg3" class="anLiBigImg" alt>
        <!-- <div class="positionText">GXG</div> -->
      </div>
      <div class="anLiBox">
        <img v-lazy="anLiBoxImg4" class="anLiBigImg" alt>
        <!-- <div class="positionText">热风</div> -->
      </div>
    </div>
    <!-- end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/wisdomTopBanner.png";

import valueLeft from "@/assets/images/wisdomPlanLeft.png";

import wisdomLeftFu from "@/assets/images/jiaZhiBottom.png";
import valueRight from "@/assets/images/wisdomPlanRight.png";
import valueRight1 from "@/assets/images/valueRight1.png";
import valueRight2 from "@/assets/images/valueRight2.png";
import valueRight3 from "@/assets/images/valueRight3.png";
import valueRight4 from "@/assets/images/valueRight4.png";
import valueRight5 from "@/assets/images/valueRight5.png";
import valueRight6 from "@/assets/images/valueRight6.png";
import boxImg1 from "@/assets/images/boxImg1.png";
import boxImg2 from "@/assets/images/boxImg2.png";
import boxImg3 from "@/assets/images/boxImg3.png";
import boxImg4 from "@/assets/images/boxImg4.png";
import planLeftImg from "@/assets/images/planLeftImg.png";
import planRightImg from "@/assets/images/planRightImg.png";
import bottomIcon1 from "@/assets/images/bottomIcon1.png";

import anLiBoxImg1 from "@/assets/images/anLiBoxImg1.png";
import anLiBoxImg2 from "@/assets/images/anLiBoxImg2.png";
import anLiBoxImg3 from "@/assets/images/anLiBoxImg3.png";
import anLiBoxImg4 from "@/assets/images/anLiBoxImg4.png";
import rev5 from "@/assets/images/rev5.png";
import reYiTi from "@/assets/images/reYiTi.png";
import rePinJie from "@/assets/images/rePinJie.png";
import tabLineImg from "@/assets/images/tabLineImg.png";
import Bread from "@/components/bread.vue";
// v5
import yingJianImg1 from "@/assets/images/wisdomBottomIcon1.png";
// 一体机
import yingJianImg4 from "@/assets/images/wisdomBottomIcon2.png";
// 8mm
import yingJianImg5 from "@/assets/images/wisdomBottomIcon3.png";
export default {
  name: "PlanDetail",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      reYiTi: reYiTi,
      rev5: rev5,
      rePinJie: rePinJie,
      toBreadChild: ["方案", "智慧门店"],
      bgImg: bgImg,
      yingJianImg1: yingJianImg1,
      yingJianImg4: yingJianImg4,
      yingJianImg5: yingJianImg5,
      wisdomLeftFu: wisdomLeftFu,
      valueLeft: valueLeft,
      valueRight: valueRight,
      valueRight1: valueRight1,
      valueRight2: valueRight2,
      valueRight3: valueRight3,
      valueRight4: valueRight4,
      valueRight5: valueRight5,
      valueRight6: valueRight6,
      boxImg1: boxImg1,
      boxImg2: boxImg2,
      boxImg3: boxImg3,
      boxImg4: boxImg4,
      planLeftImg: planLeftImg,
      planRightImg: planRightImg,
      bottomIcon1: bottomIcon1,
      anLiBoxImg1: anLiBoxImg1,
      anLiBoxImg2: anLiBoxImg2,
      anLiBoxImg3: anLiBoxImg3,
      anLiBoxImg4: anLiBoxImg4,
      tabLineImg: tabLineImg
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
  border: 3px solid #000;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}

/* end */
.contentTextOne {
  font-size: 2.4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
  width: 70%;
  margin: auto;
  max-width: 1010px;
  margin-top: 82px;
  /* text-indent: 2em; */
  text-align: center;
}

.planValue {
  background: rgba(240, 240, 240, 1);
}

.paddingTop87 {
  padding-top: 87px;
}

.planValueTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 73px;
  text-align: center;
  margin-top: 59px;
}

.planValueTu::after {
  content: "";
  display: block;
  clear: both;
}

.planValueTu {
  width: 70%;
  margin: auto;
  margin-top: 89px;
  padding: 80px 0;
}

.planValueLeft {
  width: 49%;
  float: left;
  background: #fff;
}

.planValueRight {
  width: 49%;
  float: right;
  background: #fff;
}

.lineBottom {
  height: 1px;
  background: rgba(240, 240, 240, 1);
}

.lineBottom {
  margin-top: 54px;
  margin-bottom: 36px;
}

.valueContent {
  padding: 0 30px;
  display: flex;
}

.yellowIcon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: rgba(252, 200, 0, 1);
}

.blackIcon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: rgba(49, 49, 49, 1);
}

.yellowRightFont {
  font-size: 1.8rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.valueContentTwo {
  padding: 0 30px;
}

.valueLeft {
  vertical-align: top;
  width: 100%;
}

.valueFlex {
  display: flex;
  justify-content: space-around;
}

.valueFlexBox {
  text-align: center;
  width: 33%;
  font-size: 1.6rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
}

.valueFlexBox img {
  margin: 99px 0 30px;
}

.valueBottomFlex {
  display: flex;
  margin-bottom: 55px;
  width: 83%;
  margin: auto;
}

.valueBottomBox {
  font-size: 1.6rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
  width: 20%;
  text-align: center;
}

.toRightIcon {
  color: #fcc800;
}

.boxTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 73px;
  margin-top: 75px;
  margin-bottom: 30px;
}

.changJingBox {
  text-align: center;
}

.marginTop89 {
  margin-top: 89px;
}

.bottomTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 73px;
  margin: 70px 0 113px;
}

.bottomParent::after {
  content: "";
  display: block;
  clear: both;
}

.bottomParent {
  width: 70%;
  min-width: 810px;
  margin: auto;
  margin-top: 86px;
  text-align: center;
}

.bottomLeft {
  width: 49%;
  float: left;
  border: 1px solid rgba(191, 191, 191, 1);
  height: 1065px;
}

.bottomRight {
  width: 49%;
  float: right;
  background: rgba(240, 240, 240, 1);
  height: 1065px;
}

.bottomRight img {
  max-height: 139px;
}

.imgBottomTitle {
  font-size: 2.4rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 39px;
  margin: 154px 0 56px;
}

.imgBottomText {
  width: 80%;
  margin: auto;
  font-size: 2.4rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 39px;
}

.imgBottomFlex {
  display: flex;
  width: 60%;
  margin: auto;
}

.imgBottomBox {
  flex-grow: 1;
}

.imgBottomBox img {
  margin: 103px 0 10px;
}

.v5Css {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.anLiFlex {
  display: flex;
  width: 70%;
  margin: auto;
  justify-content: space-around;
  margin-top: 85px;
}

.anLiBox {
  position: relative;
  width: 24%;
}

.positionText {
  position: absolute;
  width: 73px;
  height: 23px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  font-size: 2.4rem;
  font-family: PingFangSC-Medium;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 39px;
}

.contentBgImg {
  width: 100%;
}

.tabBoxParent {
  width: 70%;
  max-width: 1205px;
  position: relative;
  margin: auto;
}

.tabFlex {
  width: 100%;
  max-width: 1205px;
  margin: auto;
  display: flex;
  position: absolute;
  bottom: 7px;
  left: calc(50% - 50%);
}

.tabBox {
  flex-grow: 1;
  text-align: center;
  font-size: 2.4rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 39px;
  position: relative;
}

.tobLineImgCss {
  position: absolute;
  right: 0;
  bottom: 2px;
}

.tabBoxText {
  margin-bottom: 20px;
  transition: 0.5s;
}

.tabBoxText:hover {
  color: #fcc800;
}
.anLiBigImg {
  width: 100%;
  max-width: 295px;
}
</style>



// WEBPACK FOOTER //
// src/view/PlanDetail.vue